import { useState } from "react";
import { Input, message } from "antd";
import Clock from "react-live-clock";
// import { Ice1, Ice2 } from "../../../../assets/holidays/icons";
import { useAuth } from "../../../../authentication/authHelpers";
import dayjsTZ from "../../../../utils/dayjs";
import { useMediaQuery } from "react-responsive";
import { eventTracker } from "../../../../utils/eventTracker";
import { showErrorMsg } from "../../../Documentation/utils/Messages";

const { TextArea } = Input;

// const iceStates = {
//   0: null,
//   1: <Ice1 height={65} />,
//   2: <Ice2 height={75} />,
// };

function ClockInActive({
  editedTime,
  setShowConfirm,
  setShowYesterday,
  whiteListError,
  notes,
  onShiftNote,
}) {
  const auth = useAuth();
  const isMobileView = useMediaQuery({
    query: "(max-width: 450px)",
  });

  // const [iceState, setIceState] = useState(2);

  const currEmployeePayroll = auth.employee?.employeePayrollType;

  const handleClockIn = () => {
    if (currEmployeePayroll === "Page bazuar ne ore") {
      if (!!whiteListError) {
        const content =
          whiteListError +
          " Ju lutemi kontaktoni menaxherin tuaj për të filluar turnin.";
        showErrorMsg({ content });
        return;
      }
      // if (iceState > 0) {
      //   setIceState((prev) => prev - 1);
      // } else {
      setShowConfirm(true);
      eventTracker("Clock In", "click", "Opened clockin modal");
      !isMobileView && navigator.clipboard.writeText(dayjsTZ().format("HH:mm"));
      // }
    } else {
      message.error(
        "Ju nuk mundeni të filloni turnin pasi nuk keni një pagë të bazuar në orë!"
      );
    }
  };

  return (
    <div className="clock-in-active">
      {" "}
      <div className="time-indicator">
        {/* <h4 style={{ color: "#ea3943" }}>{moment(time).format("HH:mm")}</h4>{" "} */}
        {/* <h4 style={{ color: "#ea3943" }}>
          {" "}
          <Clock format={"HH:mm"} ticking={true} timezone={"Europe/Tirane"} />
        </h4> */}
        {/* <span className="live-icon">
            <LiveIcon />
        </span> */}
      </div>
      <div
        className="clock-in-content"
        // style={{ marginTop: editedTime !== null ? "0px" : "0px" }}
      >
        {/* <div className="clock-in-logo-container"></div> */}

        <div className="actionful">
          <div className="start-shift-cont">
            <span className="welcomeMessage">
              <h1>Përshëndetje!</h1>
            </span>
            {/* <TimePicker
                className="timepick"
                defaultValue={time}
                disabled
                value={
                  customTime ? null : editedTime !== null ? editedTime : time
                }
                format={"HH:mm"}
                allowClear={false}
                onChange={onCustomStartTime}
                onOpenChange={(boolVal) => setCustomTime(boolVal)}
                disabledHours={getDisabledAfterHours}
                disabledMinutes={getDisabledAfterMinutes}
              /> */}
            <span
              className="start-shift-btn"
              style={{
                width: "160px",
                //winter
                // ...(iceState === 1
                //   ? { background: "#016a85" }
                //   : iceState === 2
                //   ? { background: "#006cab" }
                //   : {}),
                //end winter
              }}
              onClick={handleClockIn}
            >
              {/* {iceStates[iceState]} */}
              Fillo Turnin
            </span>
            <div className="currentTime">
              Ora Tani:{" "}
              <Clock
                format={"HH:mm"}
                ticking={true}
                timezone={"Europe/Tirane"}
              />
            </div>
            <span
              className="yesterday-shift-btn"
              style={{ textAlign: "center" }}
              onClick={() => setShowYesterday(true)}
            >
              Shikoni prezencën në të kaluarën{" "}
            </span>
          </div>
        </div>
      </div>
      {editedTime && (
        <div className="justify-note-wrapper" style={{ marginTop: "10px" }}>
          <TextArea
            // autoSize={false}
            value={notes?.clockInNote}
            onChange={(e) => onShiftNote(e, "clockInNote")}
            classname="justify-note"
            placeholder="Shkruaj një shënim këtu..."
            autoSize={{ minRows: 2, maxRows: 2 }}
          />
        </div>
      )}
    </div>
  );
}

export default ClockInActive;
